import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Autocomplete, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import EAButton from '../../../../../../components/common/EAButton';
import i18next from 'i18next';
import { getTPContacts } from '../../../../../../services/edge/ThirdpartyService';
import { Context } from '../../../../../../states/Store';

const SearchTiersContact = ({ thirdpartyId, addContact }) => {
  const [state, dispatch] = useContext(Context);
  const [tpContacts, setTpContacts] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const fetchContacts = useCallback(async () => {
    const res = await getTPContacts(state.account.id, thirdpartyId, dispatch);
    setTpContacts(res.content.map((r) => r.email));
  }, [state.account.id, thirdpartyId, dispatch]);

  useEffect(() => {
    fetchContacts();
  }, [fetchContacts]);

  return (
    <Autocomplete
      freeSolo
      options={tpContacts}
      inputValue={inputValue}
      disableClearable
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder="Chercher par adresse mail ou ajouter en une"
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#fff',
              border: 'none',
              boxShadow: 'none',
              height: '48px',
              borderRadius: '4px',
              width: '480px',
            },
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
            startAdornment: (
              <>
                {params.InputProps.endAdornment}
                <InputAdornment position="start">
                  <EAButton
                    variant="contained"
                    onClick={() => addContact(inputValue)}
                    content={i18next.t(`add`)}
                    customStyle={{
                      height: '32px',
                      minHeight: '0px',
                      minWidth: '0px',
                      width: '91px',
                      fontSize: '12px',
                      fontWeight: '600',
                      padding: 0,
                    }}
                  />
                </InputAdornment>
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default SearchTiersContact;
